import type { FeatureReferenceBinding } from '../../binding/FeatureReferenceBinding';
import type { FeatureDefinition } from '../../definition/FeatureDefinition';
import type { FeatureEditSession } from '../../edit/FeatureEditSession';
import type { FeaturePrototype } from '../../prototype/FeaturePrototype';
import type { FeaturePreviewPresentationData } from './FeaturePreviewPresentation';

/**
 * 特征预览执行输入。
 */
export interface FeaturePreviewExecutionInput {
    /** 特征种类。 */
    featureKind: string;
    /** 编辑态特征 ID。 */
    featureId?: string | null;
    /** 预览定义。 */
    definition: FeatureDefinition;
    /** 已解析的输入绑定。 */
    bindings: FeatureReferenceBinding[];
    /** 当前编辑会话。 */
    session: FeatureEditSession | null;
    /** 预览引导优先绑定的选择项引用，仅影响气泡等展示语义。 */
    preferredItemRef?: string | null;
}

/**
 * 特征预览执行结果。
 */
export interface FeaturePreviewExecutionResult {
    /** 预览 mesh 数据。 */
    meshData: MeshData;
    /** 预览附加表达数据。 */
    presentation?: FeaturePreviewPresentationData | null;
    /** 结果对应的特征原型。 */
    prototype: FeaturePrototype;
    /** 本次预览使用的草稿定义。 */
    draftDefinition: FeatureDefinition;
    /** 旋转切除保留实体高亮网格。 */
    fragmentMeshes?: RevolveCutPreviewFragmentMesh[];
}

/**
 * 特征预览执行处理器抽象基类。
 */
export abstract class FeaturePreviewExecutionHandler {
    /**
     * 判断当前处理器是否支持指定输入。
     *
     * @param input 预览输入。
     * @returns 是否支持。
     */
    public abstract supports(input: FeaturePreviewExecutionInput): boolean;

    /**
     * 执行预览。
     *
     * @param input 预览输入。
     * @returns 预览结果。
     */
    public abstract execute(input: FeaturePreviewExecutionInput): Promise<FeaturePreviewExecutionResult>;
}
